// extracted by mini-css-extract-plugin
export var Blog = "TitleTextButtonSection-module--Blog--c4616";
export var Rh = "TitleTextButtonSection-module--Rh--53dc8";
export var btn = "TitleTextButtonSection-module--btn--b7cb9";